import { useEffect, useRef, useState } from 'react'
import './BotonFlotante.css'
import generateAnswer from './generateAnswer'
import conversationFlow from './conversationFlow'

function BotonFlotante() {

  const messagesRef = useRef(null)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [lastBotMessage, setLastBotMessage] = useState(null)
  const [messages, setMessages] = useState([
    <p className="BotonFlotante-botMessage">¡Hola! Vamos a verificar si cuentas con cobertura.</p>,
    <p className="BotonFlotante-botMessage">¿Cuál es tu nombre?</p>
  ])
  const [storedData, setStoredData] = useState({
    nombre: '',
    telefono: '',
    direccion: ''
  })

  //¿Cual es tu número de telefono?
  //Ingresá tu dirección completa(dirección, entre calles, localidad, cp)
  //Gracias, en breve te vamos a enviar toda la información al número que nos brindaste 🙂

  const onFormSubmit = e => {
    e.preventDefault()
    setMessages(prevMessages => {
      const generatedAnswer = generateAnswer(conversationFlow, message, lastBotMessage)
      const newBotMessages = []
      if (generatedAnswer) {
        setLastBotMessage(generatedAnswer)
        const generatedMessages = generatedAnswer.callback ? generatedAnswer.callback(message, storedData, setStoredData) : generatedAnswer.messages
        newBotMessages.push(...generatedMessages)
      } else {
        newBotMessages.push(...lastBotMessage.fallbackMessages)
      }
      return [...prevMessages, <p className="BotonFlotante-userMessage">{message}</p>, ...newBotMessages]
    })
  }

  useEffect(() => {
    setMessage('')
    messagesRef.current.scrollTop = messagesRef.current.scrollHeight
  }, [messages])

  return (
    <div className="BotonFlotante">
      <div className="BotonFlotante-main" style={open ? { transform: 'scale(1)', height: '300px', transition: 'height 0s, transform .4s 0s' } : { transform: 'scale(0)', height: '0px', transition: 'height 0s .4s, transform .4s 0s' }}>
        <p className="BotonFlotante-header">Contactanos ahora</p>
        <div className="BotonFlotante-botMessages" ref={messagesRef}>
          {messages}
        </div>
        <form onSubmit={onFormSubmit}>
          <input className="BotonFlotante-input" type="text" required value={message} onChange={e => setMessage(e.target.value)} placeholder="Escribe un mensaje" />
          <input className="BotonFlotante-submit" type="submit" value="Enviar" />
        </form>
      </div>
      <button className="BotonFlotante-button" onClick={() => setOpen(prevOpen => !prevOpen)}>{open ? 'Cerrar' : 'Contactanos'}</button>
    </div>
  )
}

export default BotonFlotante